"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemFeesProductNames = exports.CBD_THC_UNIT = exports.CSVProductHeaders = exports.ProductsExportFileType = void 0;
var ProductsExportFileType;
(function (ProductsExportFileType) {
    ProductsExportFileType["CSV"] = "csv";
})(ProductsExportFileType || (exports.ProductsExportFileType = ProductsExportFileType = {}));
var CSVProductHeaders;
(function (CSVProductHeaders) {
    CSVProductHeaders["ID"] = "ID";
    CSVProductHeaders["SKU"] = "SKU";
    CSVProductHeaders["PARENT_ID"] = "Parent ID";
    CSVProductHeaders["PARENT_SKU"] = "Parent SKU";
    CSVProductHeaders["FULL_NAME"] = "Full Name";
    CSVProductHeaders["NAME"] = "Name";
    CSVProductHeaders["PARENT_NAME"] = "Parent Name";
    CSVProductHeaders["IMAGE_URL"] = "Image URL";
    CSVProductHeaders["IS_ACTIVE"] = "Is Active";
    CSVProductHeaders["IS_MASTER_PRODUCT"] = "Is Master Product";
    CSVProductHeaders["IS_TRACKING_INVENTORY"] = "Is Tracking Inventory";
    CSVProductHeaders["PRICE"] = "Retail Price";
    CSVProductHeaders["CATEGORY"] = "Category";
    CSVProductHeaders["BRAND"] = "Brand";
    CSVProductHeaders["DEPOSIT_FEE"] = "Deposit Fee";
    CSVProductHeaders["TAX"] = "Tax";
    CSVProductHeaders["PURCHASE_PRICE"] = "Wholesale Cost";
    CSVProductHeaders["DESCRIPTION"] = "Description";
    CSVProductHeaders["BARCODE"] = "Barcode";
    CSVProductHeaders["SHORT_DESCRIPTION"] = "Receipt Description";
    CSVProductHeaders["WEIGHT"] = "Net Product Weight";
    CSVProductHeaders["CANNABIS_WEIGHT"] = "Cannabis Weight";
    CSVProductHeaders["CANNABIS_VOLUME"] = "Cannabis Volume";
    CSVProductHeaders["THC"] = "THC";
    CSVProductHeaders["CBD"] = "CBD";
    CSVProductHeaders["MAX_CBD"] = "Max CBD";
    CSVProductHeaders["MIN_CBD"] = "Min CBD";
    CSVProductHeaders["MAX_THC"] = "Max THC";
    CSVProductHeaders["MIN_THC"] = "Min THC";
    CSVProductHeaders["SHOW_MAX_MIN"] = "Show Min Max THC CBD";
    CSVProductHeaders["UNIT"] = "THC/CBD Unit";
    CSVProductHeaders["TRACK_LOTS"] = "Track Lots";
    CSVProductHeaders["TAGS"] = "Tags";
    CSVProductHeaders["STRAIN_TYPE"] = "Strain Type";
    CSVProductHeaders["CREATED"] = "Created";
    CSVProductHeaders["UPDATED"] = "Updated";
})(CSVProductHeaders || (exports.CSVProductHeaders = CSVProductHeaders = {}));
var CBD_THC_UNIT;
(function (CBD_THC_UNIT) {
    CBD_THC_UNIT["PERCENT"] = "%";
    CBD_THC_UNIT["MG"] = "mg";
    CBD_THC_UNIT["ML"] = "ml";
    CBD_THC_UNIT["MG_G"] = "mg/g";
    CBD_THC_UNIT["MG_ML"] = "mg/mL";
})(CBD_THC_UNIT || (exports.CBD_THC_UNIT = CBD_THC_UNIT = {}));
var SystemFeesProductNames;
(function (SystemFeesProductNames) {
    SystemFeesProductNames["SHIPPING"] = "shipping";
    SystemFeesProductNames["TIP"] = "tip";
    SystemFeesProductNames["SURCHARGE"] = "surcharge";
})(SystemFeesProductNames || (exports.SystemFeesProductNames = SystemFeesProductNames = {}));
//# sourceMappingURL=productV2.js.map